export default __webpack_public_path__ + "static/media/GalanoGrotesque-Bold.32a0e8c8.woff2";